/**
 * @file コンポーネント：フル動画ページ機器広告コンテンツ ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ContentsAd = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
